import * as TradingView from './charting_library';
import { ungzip } from './pakoref';

import { AlertsState } from './alerts';
import { ActionCallback, apiBase, ApiErr, EmptyCallback, UserRoles } from './api';
import { userApi } from './api/user';
import { CacheStorage } from './cacheStorage';
import { ChartConfig, ScopeIds, SettingsScope } from './config/config';
import { GeneralConfig } from './config/general-config';
import { UserTheme } from './config/misc';
import { TickerInfo, TimeFrame } from './config/tickers';
import { BuiltAlertMsg, BuiltAlertTicker, UserSettings, UserTicker, UserTickerType, USUserInfo } from './config/user';
import { ThemeName, TVContext } from './hub/context';
import { BarData, TickerTFInfo } from './hub/datafeed';
import { TVHelper } from './hub/helper';
import { SignalHub } from './hubSignal';
import { SmpaTool } from './smpa';
import { InfoBuilder } from './smpa/infobox';
import { SmpaTFInfo } from './smpa/smpainfo';
import { getJson, isSet, setFlag, setJson } from './storage';
import { TradingHub } from './trading/tradingHub';
import { TVSyncer } from './tv/sync';

export class hubTFData {
    rt: TickerTFInfo;
    //bars: BarData[] = [];
    startBar: number;
    dataStart: number;
    tf: string;
    constructor(tf: string) {
        this.tf = tf;
    }
    //get lastRecord() {
    //	if (this.bars.length == 0)
    //		return null;
    //	return this.bars[this.bars.length - 1].t;
    //}
}

export class hubItemsData {
    tid: string = null;
    replayMode: boolean = false;
    smpa = new Map<string, SmpaTFInfo>();
    tfd = new Map<string, hubTFData>();
    tickerInfo: TickerInfo = null;
    smpaAt = 0;
    constructor(tid: string) {
        this.tid = tid;
    }
    getSmpa(res: string): SmpaTFInfo {
        return this.smpa.get(res);
    }

    getBars(res: string): hubTFData {
        let r = this.tfd.get(res);
        if (r == null)
            this.tfd.set(res, r = new hubTFData(res))
        return r;
    }
}

export class hubTickerData {
    tickers = new Map<string, hubItemsData>();
    //hasSmpa = false;

    //getItem(tv: TradingView.IChartingLibraryWidget, data: boolean): SmpaTFInfo | hubTFData {
    //  const activeChart = tv.activeChart();
    //  const tid = activeChart.symbol();
    //  const ticker = this.getTicker(tid);
    //  return ticker.getItem(activeChart, data);
    //}
    getSmpa(tid: string, tf: string): SmpaTFInfo {
        return this.getTicker(tid).getSmpa(tf);
    }
    getBars(tid: string, tf: string): hubTFData {
        return this.getTicker(tid).getBars(tf);
    }
    getTicker(tid: string) {
        let ticker = this.tickers.get(tid);
        if (ticker == null) {
            ticker = new hubItemsData(tid);
            this.tickers.set(tid, ticker);
        }
        return ticker;
    }
    isReplayMode(tid: string) {
        return this.getTicker(tid).replayMode;
    }
    setReplayMode(tid: string, active: boolean) {
        this.getTicker(tid).replayMode = active;
    }
}

export type AutoScaleChangedCallback = (context: TVContext, tv: boolean) => void;
export type TickerChangedCallback = (context: TVContext, init: boolean) => void;
export type CrossHairChangedCallback = (context: TVContext, bar: BarData) => void;
export type VisibleRangeChangedCallback = (context: TVContext, p: TradingView.VisibleTimeRange) => void;
export type OnLoadedAlertsCallback = ActionCallback<AlertsState>;
export type OnContextCallback = ActionCallback<TVContext>;
export type OnBusyCallback = ActionCallback<boolean>;
export type OnTickersCacheCallback = ActionCallback<TickerInfo[]>;
export type OnTVInitCallback = (params: TradingView.ChartingLibraryWidgetOptions, id: number) => void;

interface PongResuls extends ApiErr {
    tid: string;
    st: number;
    d: TickerTFInfo[];
    sd: ArrayBufferLike;
    v: string;
}
export enum DrawingControl {
    Disabled,
    Enabled,
    Lock,
}
export enum UserNotificationType {
    Verified,
    Settings,
    Expiration,
    Suspend,
    Locked,
    SharedMTFs,
    Tickers,
    Language = 100,
    CallbackMsg,
    Verification,
    Paused,
    NewVersion,
    ExpiresInADay
}
export interface UserNotification {
    type: UserNotificationType;
    msg: string;
}

export interface InitHubOptions {
    apiUrl: string;
    sessionId: string;
    userId: number;
    isAdmin: boolean;
    smpa: boolean;
    onSessionExpired: EmptyCallback;
    onBusy: OnBusyCallback;
    legendVisible: boolean;
    theme: UserTheme;
    drawingControl: DrawingControl;
    viewPortSync: boolean;
    lang: string;
}
export enum UpdateViewType {
    TV = 1,
    Smpa = 2,
    General = 4,
    TVSmpa = TV | Smpa,
    All = TV | Smpa | General
}

export enum UpdateViewField {
    Some,
    Color
}
export enum Bias {
    Both,
    Bull,
    Bear
}

export interface DisplayAlert {
    msgs: BuiltAlertMsg[];
    ticker: TickerInfo;
    ib: boolean;
}

class Hub extends SignalHub {
    private lastSubId: string;
    private lastScopeId: number;
    private tvs: TVContext[] = [];
    private initedTVs = 0;
    private updating = 0;
    private setTickerUpdates = 0;
    private data = new hubTickerData();
    private tvInit: TradingView.DatafeedConfiguration = null;
    private syncer: TVSyncer = null;
    private busy = 0;
    private suspended = false;
    private subsribedScopeId: ScopeIds;
    private curVersion: string;
    private _tradingHost: string;
    private _cache: CacheStorage;
    private _trading: TradingHub;
   

    uitheme: UserTheme;
    tvtheme: UserTheme;
    config: SettingsScope = null;
    userinfo: USUserInfo;
    admin: boolean;
    tfs: Map<string, TimeFrame> = new Map<string, TimeFrame>();
    tfsByDisp: Map<string, TimeFrame> = new Map<string, TimeFrame>();
  
    options: InitHubOptions;
    bias: Bias;
   
    debugApi: boolean = false;


    tickers = new Map<string, TickerInfo>();
    storedTickers = new Map<string, TickerInfo>();
    favoriteTickers = new Map<UserTickerType, Set<string>>();
    alertingTickers = new Set<string>();

    get cache() { return this._cache; }
    get trading() { return this._trading; }
    get tradingHost() { return this._tradingHost; }

    onReconnected: EmptyCallback;;
    onUserExpired: EmptyCallback;
    onScreenshotReady: ActionCallback<string>;
    onUserNotification: ActionCallback<UserNotification>;
    getTickersData = (): hubTickerData => this.data;
    onTickersChanged: EmptyCallback;
    onTickersCacheChanged: OnTickersCacheCallback;
    onAlertMsgsChanged: ActionCallback<BuiltAlertTicker>;


    displayAlert: DisplayAlert;

    constructor() {
        super();
        let lockResolver: any = null;
        if (navigator && navigator.locks && navigator.locks.request) {
            const promise = new Promise((res) => {
                lockResolver = res;
            });

            navigator.locks.request('mark_tools_lock', { mode: "shared" }, () => {
                return promise;
            });
        }
        document.addEventListener('sleep', () => this.sleepEvent(true));
        document.addEventListener('wake', () => this.sleepEvent(false));
        this._cache = new CacheStorage();
        this.syncer = new TVSyncer();
        this._trading = new TradingHub(this.syncer);
    }

    private sleepEvent = (sleep: boolean) => {
        if (sleep)
            console.warn('put into sleep');
        else
            console.warn('awaik from sleep');
    }

    getUserSettings = async () => {
        return userApi.post<UserSettings>("getUserSettings").then(us => {
            hub.config = us.config;
            hub.admin = isSet(us.ui.tls, UserRoles.ManageData);
            hub.debugApi = us.debug;
            hub.curVersion = us.version;
            hub.userinfo = us.ui;
            hub.signalNost = us.signal;
            hub._tradingHost = us.trading;
            hub.onThemeChanged();
            hub.favoriteTickers.clear();
            for (const tf of us.tfs) {
                hub.tfs.set(tf.tv, tf);
                hub.tfsByDisp.set(tf.disp, tf);
            }

            hub.tvInit = us.tvInit;
            if (us.layouts)
                for (let i = 0; i < us.layouts.length; i++)
                    us.layouts[i] = {
                        n: us.layouts[i].n,
                        c: JSON.parse(us.layouts[i].c)
                    };
            (us.tickers ?? []).forEach(x => {
                if (isSet(x.type, UserTickerType.Alert))
                    hub.alertingTickers.add(x.id);
                const flg = setFlag(x.type, UserTickerType.Alert, false);
                if (isSet(flg, UserTickerType.Favorite)) {
                    let ts = hub.favoriteTickers.get(flg);
                    if (ts == null) hub.favoriteTickers.set(flg, ts = new Set<string>());
                    ts.add(x.id);
                }
            });

            for (const t of getJson<TickerInfo[]>('tickers_cache') ?? []) {
                hub.storedTickers.set(t.id, t);
                hub.tickers.set(t.id, t);
            }
            hub.initHub(`https://${hub.signalNost}/hub`);
            return us;
        });
    }
    protected override subscribeToHub() {
        this.connection.on("SendAlerts", async (data: BuiltAlertTicker) => {
            if (data == null)
                return;
            setTimeout(() => {
                if (this.onAlertMsgsChanged)
                    this.onAlertMsgsChanged(data);
            });
        });

        this.connection.on("UpdateSandbox", async (data: PongResuls) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any,sonarjs/prefer-immediate-return
            const promise = new Promise((resolve: (value: string) => void, rejected: (reason: string) => void) => {
                if (this.isSuspended)
                    return;
                if (data.error != null) {
                    apiBase.state.validateSession(data);
                    rejected(data.error);
                }
                else if (this.isInited()) {
                    if (this.curVersion != data.v && data.v) {
                        this.curVersion = data.v;
                        hub.onUserNotification({
                            type: UserNotificationType.NewVersion,
                            msg: null
                        });
                    }
                    try {
                        const isdata = data.d != null;
                        const ticker = hub.data.getTicker(data.tid);
                        if (isdata) {
                            if (!ticker.replayMode) {
                                for (let i = 0; i < data.d.length; i++) {
                                    const tfd = ticker.getBars(data.d[i].tf_tv);
                                    tfd.rt = data.d[i];
                                }
                                for (let j = 0; j < this.tvs.length; j++)
                                    this.tvs[j].updateTVBars();
                            }
                        } else if (!ticker.replayMode || data.st == 1983 && ticker.replayMode) {
                            ticker.smpaAt = data.st;
                            if (data.sd) {
                                const unpacked = ungzip(data.sd, { to: 'string' });
                                const tfs = JSON.parse(unpacked) as SmpaTFInfo[];
                                if (tfs == null) {
                                    console.log('cannot unzip');
                                    return;
                                }
                                for (let i = 0; i < tfs.length; i++)
                                    ticker.smpa.set(tfs[i].tf_tv, tfs[i]);
                            }
                            for (let j = 0; j < this.tvs.length; j++)
                                this.tvs[j].updateTVSmpa();
                        }

                    } catch (e) {
                        console.error(e);
                    }
                    resolve(null);
                }
            });
            return promise;
        });
        this.connection.on("NotifyUser", (x: UserNotification) => {
            if (this.onUserNotification)
                this.onUserNotification(x);
            else
                alert(UserNotificationType[x.type]);
            if (x.type == UserNotificationType.Suspend) {
                this.suspended = true;
                this.connection.stop();
            }
        });
    }

    // eslint-disable-next-line sonarjs/cognitive-complexity
    async init(options: InitHubOptions) {
        console.log('init');
        apiBase.state.onUserExpired = (x) => {
            this.stopHub();
            if (this.onUserExpired != null)
                this.onUserExpired();
        };
        apiBase.setAuth(options.apiUrl, options.sessionId, options.userId, options.onSessionExpired);
        if (this.connection != null) {
            this.connection.stop();
            return;
        }
        TVHelper.legenedVisible = options.legendVisible;
        this.options = options;
        this.bias = Bias.Both;
        this.uitheme = options.theme != null ? options.theme : UserTheme.Light;
        this.tvtheme = this.uitheme;
    }
    protected override get canStartHub() { return !this.isSuspended; }

    protected override onBeforeHubStarted() {
        this.lastSubId = null;
   
    }
    protected override async onEndHubStarted() {
        apiBase.state.hubId = this.connection.connectionId;
        console.log("SignalR Connected.");
        if (this.isInited())
            if (await this.subscribe())
                console.log("SignalR restored subs");
            else
                console.log("SignalR failed to restore subs")
        
        if (this.onReconnected)
            setTimeout(() => this.onReconnected(), 0);
    }

    private async subscribe(): Promise<boolean> {
        try {
            if (this.isUpdating())
                throw new DOMException('hub is in updating mode');
            if (!this.isHubConnected)
                return false;
            if (this.tvs.length == 0)
                return false;
            const r = new Map<string, { tid: string, smpaAt: number }>();
            const scopeId = this.config.chart.scopeId;
            const scopeChanged = this.config.chart.scopeId != this.lastScopeId && this.lastScopeId != null;
            for (let i = 0; i < this.tvs.length; i++) {
                const tvd = this.tvs[i];
                const tid = tvd.tid;
                let smpaAt = -1;
                if (this.hasSmpa()) {
                    smpaAt = this.data.getTicker(tid).smpaAt;
                    if (scopeChanged) smpaAt = 0;
                }
                const item = r.get(tid);
                if (item == null)
                    r.set(tid, {
                        tid: tid,
                        smpaAt: smpaAt
                    });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const ir: { tid: string, smpaAt: number }[] = [];
            const ids: string[] = [];
            if (!this.isSuspended)
                for (const v of r.values()) {
                    ids.push(v.tid);
                    ir.push(v);
                }
            const subid = ids.sort((a, b) => a.localeCompare(b)).join('_') + scopeId;
            if (this.lastSubId == subid)
                return false;
            this.lastSubId = subid;
            this.lastScopeId = scopeId;
            console.log('sub:' + this.lastSubId);
            await this.connection.invoke("Subscribe", apiBase.getFetchInput(ir)).then(() => this.subsribedScopeId = scopeId);
            return true;
        } catch (err) {
            this.lastSubId = null;
            this.lastScopeId = null;
            console.log(err);
            return false;
        }
    }
   
    get isSuspended() {
        return this.suspended || apiBase.state.isUserPaused;
    }
    hasSmpa() {
        return this.options.smpa;
    }
    isInited() {
        return this.tvs.length == this.initedTVs && this.tvs.length > 0 && this.updating == 0;
    }
    isSettingTicker() {
        return this.setTickerUpdates > 0;
    }
    isUpdating() {
        return this.updating != 0;
    }
    setBias(bias: Bias) {
        this.bias = bias;
        this.updateView(UpdateViewType.Smpa);
    }
    beginUpdate() {
        if (this.setTickerUpdates != 0)
            throw 'set ticker took place';
        const first = this.updating++ == 0;
        if (first) {
            this.syncer.beginUpdate();
            this.beginBusy();
        }
        this.syncer.dispose();
        for (const tvd of this.tvs)
            tvd.dispose();
        this.tvs = [];
        this.initedTVs = 0;
    }

    endUpdate() {
        if (this.updating == 0)
            throw 'beginUpdate is not detected';
        if (--this.updating == 0) {
            this.syncer.endUpdate();
            if (this.isInited())
                this.subscribe();
            this.endBusy();
        }
    }
    get isBusy() { return this.busy != 0; }
    beginBusy() {
        if (++this.busy == 1)
            try {
                if (this.options.onBusy)
                    this.options.onBusy(true);
            } catch (e) {
                console.error(e);
            }
    }
    endBusy() {
        if (this.busy > 0) {
            if (--this.busy == 0)
                try {
                    if (this.options.onBusy)
                        this.options.onBusy(false);
                } catch (e) {
                    console.error(e);
                }
        }
    }
    enumTVs(onTV: OnContextCallback) {
        for (let i = 0; i < this.tvs.length; i++)
            onTV(this.tvs[i]);
    }
    updateView(type = UpdateViewType.All, field = UpdateViewField.Some) {
        this.onThemeChanged();
        if (isSet(type, UpdateViewType.TV) || isSet(type, UpdateViewType.General))
            TVHelper.overrides(true);
        for (let i = 0; i < this.tvs.length; i++)
            this.tvs[i].updateView(type, false, field);
    }
    get count() {
        return this.tvs.length;
    }
    get smcConfig() { return this.config?.chart?.smpa; }
    get tvConfig() { return this.config?.chart?.tv; }

    private onInited() {
        // eslint-disable-next-line sonarjs/no-collapsible-if
        if (++hub.initedTVs == hub.tvs.length) {
            if (hub.isInited()) {
                hub.subscribe();
                hub.syncer.onInited();
            }
        }
    }
    private onThemeChanged() {
        if (this.uitheme == UserTheme.Light)
            this.tvtheme = this.config.chart.tv.light;
        else
            this.tvtheme = this.config.chart.tv.dark;
    }
    private onBeginContextChange(ctx: TVContext) {
        hub.beginBusy();
    }
    private onEndContextChange(ctx: TVContext) {
        hub.endBusy();
    }
    private onBarReplayChanged(ctx: TVContext) {
        const tid = ctx.tid;
        for (const tvd of hub.tvs)
            if (tvd.tid == tid)
                tvd.resetCache();
    }
    private onTickerChanged() {
        if (hub.isInited())
            hub.subscribe();
    }
    private createContext() {
        const tvd = new TVContext(this.tvs.length, {
            onInited: this.onInited,
            onTickerChanged: this.onTickerChanged,
            onBeginChange: this.onBeginContextChange,
            onEndChange: this.onEndContextChange,
            onBarReplayChanged: this.onBarReplayChanged,
            onBarsReceived: null,
            data: this.data,
            tvInit: this.tvInit,
            syncer: this.syncer,
        });
        this.tvs.push(tvd);
        return tvd;
    }

    createTV(hostId: string, libPath: string, tid: string, tf: string, infoBuilder: InfoBuilder = null, onTVInit: OnTVInitCallback = null, debugTv = false) {
        if (!tid || tid.length == 0)
            tid = "BN:BTCUSDT";
        this.cache.preload(tid);

        if (!this.isUpdating())
            throw new DOMException('hub is not in updating mode');
        const tvdata = this.createContext();
        let lang = this.options.lang;
        if (lang == 'ua')
            lang = 'ru';
        tvdata.htmlHost = document.getElementById(hostId);
        const params: TradingView.ChartingLibraryWidgetOptions = {
            container: tvdata.htmlHost,
            locale: lang as TradingView.LanguageCode,
            timezone: hub.config.tz as TradingView.Timezone,
            library_path: libPath,
            symbol: tid,
            interval: tf as TradingView.ResolutionString,
            debug: debugTv,
            datafeed: tvdata.dataFeed,
            fullscreen: false,
            autosize: false,
            context_menu: {
                items_processor: (items: any, actionsFactory: any, params: any) => {
                    console.log(`Menu name is: ${params.menuName}`);
                    const newItem = actionsFactory.createAction({
                        actionId: 'hello-world',
                        label: 'Say Hello',
                        onExecute: function () {
                            alert('Hello World');
                        },
                    });
                    items.unshift(newItem);
                    return Promise.resolve(items);
                },
            },
            //save_load_adapter: new SaveLoadAdapter(),
            loading_screen: { backgroundColor: this.tvConfig.paneProperties.background },
            settings_overrides: TVHelper.overrides(),
            overrides: TVHelper.overrides(),
            enabled_features: TVHelper.enabledFeatures(),
            disabled_features: TVHelper.disabledFeatures(),
            theme: this.tvtheme == UserTheme.Light ? ThemeName.light : ThemeName.dark,
            client_id: 'mts',
            user_id: apiBase.state.sessionId,
        };
        if (onTVInit)
            onTVInit(params, tvdata.id);
        const tv: TradingView.IChartingLibraryWidget = new TradingView.widget(params);
        tvdata.setTV(tv, tid, tf);
        this.syncer.add(tvdata);
        if (this.hasSmpa())
            try {
                tvdata.smpa = new SmpaTool(tvdata, infoBuilder);
            } catch (e) { console.error(e); }
        return tvdata;
    }

    beginSetTicker() {
        if (this.updating > 0 && this.updating != this.setTickerUpdates)
            throw 'beginUpdate took place';
        this.updating++;
        this.setTickerUpdates++;
    }

    endSetTicker() {
        if (this.setTickerUpdates == 0)
            throw 'no updating mode is detected';
        --this.setTickerUpdates;
        // eslint-disable-next-line sonarjs/no-collapsible-if
        if (--this.updating == 0)
            if (this.isInited())
                this.subscribe();
    }

    markUp(ticker: TickerInfo, ib: boolean, msgs: BuiltAlertMsg[]) {
        if (msgs == null)
            this.displayAlert = null;
        else
            this.displayAlert = {
                ticker: ticker,
                ib: ib,
                msgs: msgs
            };
        this.updateView(UpdateViewType.Smpa, null);
    }
    setTicker(tid: string) {
        this.beginSetTicker();
        try {
            this.cache.preload(tid);
            for (let i = 0; i < this.tvs.length; i++) {
                const sid = this.tvs[i].tv.activeChart().symbol();
                if (sid != tid)
                    this.tvs[i].tv.activeChart().setSymbol(tid);
            }
        } finally {
            this.endSetTicker();
        }
    }

    setTF(tf: string) {
        for (let i = 0; i < this.tvs.length; i++) {
            const stf = this.tvs[i].tv.activeChart().resolution();
            if (stf != tf)
                this.tvs[i].tv.activeChart().setResolution(tf as TradingView.ResolutionString);
        }
    }

    setTheme(theme: UserTheme) {
        this.uitheme = theme;
        this.updateView(UpdateViewType.All);
    }
    getTimeZones() {
        return this.tvs[0].tv.activeChart().getTimezoneApi().availableTimezones();
    }

    get TVs() {
        return this.tvs;
    }
    get first() {
        return this.tvs[0];
    }

    async saveConfig() {
        return hub.saveConfigAsTemplate(null, hub.config.tz, hub.config.general, hub.config.chart).then(() => {
            if (hub.subsribedScopeId != hub.config.chart.scopeId)
                hub.subscribe();
            hub.updateView();
        });
    }
    async saveConfigAsTemplate(template: string, tz: string, general: GeneralConfig, chart: ChartConfig) {
        return userApi.post<void>("saveConfig", {
            template: template,
            tz: tz,
            chart: chart,
            general: general
        });
    }
    get replayMode() {
        if (this.first)
            return this.getTickersData().isReplayMode(this.first.tid);
        return false;
    }

    setReplayMode(id: number, on: boolean) {
        this.tvs[id].setReplayMode(on);
    }

    resetCache() {
        for (const tvd of this.tvs)
            tvd.resetCache();
    }

    cacheTickers(tickers: TickerInfo[], store: boolean = true) {
        for (const t of tickers ?? [])
            this.tickers.set(t.id, t);
        if (store) {
            for (const t of tickers)
                this.storedTickers.set(t.id, t);
            setJson<TickerInfo[]>('tickers_cache', Array.from(this.storedTickers.values()));
        }
        if (this.onTickersCacheChanged && tickers)
            this.onTickersCacheChanged(tickers);
    }

    saveFavoriteTickers(tickers: {id: string, f: UserTickerType} []) {
        this.favoriteTickers.clear();
        if (tickers)
            for (const tid of tickers) {
                const t = this.tickers.get(tid.id);
                if (t) {
                    let tids = this.favoriteTickers.get(tid.f);
                    if (!tids)
                        this.favoriteTickers.set(tid.f, tids = new Set<string>());
                    tids.add(t.id);
                    this.storedTickers.set(t.id, t);
                }
            }
        setJson<TickerInfo[]>('tickers_cache', Array.from(this.storedTickers.values()));
        this.saveTickers();
    }

    saveAlertingTickers(tickers: string[]) {
        this.alertingTickers.clear();
        for (const tid of tickers ?? [])
            this.alertingTickers.add(tid);
        this.saveTickers();
    }

    saveTickers() {
        this.onTickersChanged();
        const tids = new Map<string, UserTicker>();
        add(this.alertingTickers, UserTickerType.Alert);
        for (let vs of this.favoriteTickers.keys())
            add(this.favoriteTickers.get(vs), vs);
        function add(set: Set<string>, type: UserTickerType) {
            set.forEach(x => {
                let t = tids.get(x);
                if (!t)
                    tids.set(x, t = {
                        id: x,
                        type: type
                    });
                else
                    t.type |= type;
            });
        }
        userApi.setTickers(Array.from(tids.values()));
    }
}

export const hub = new Hub();

